import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from 'src/app/service/api.service';

@Component({
  selector: 'app-recuperarsenha',
  templateUrl: './recuperarsenha.component.html',
  styleUrls: ['./recuperarsenha.component.css']
})
export class RecuperarsenhaComponent implements OnInit {

  senhanova: string = "";
  senhaconfirmar: string = "";
  lojistaid: string = "";

  constructor(private apiService: ApiService, private spinner: NgxSpinnerService, private toastr: ToastrService, private router: Router,
    private route: ActivatedRoute) {
    this.route.params.subscribe(params => {
      this.lojistaid = params['id'];
    });
  }

  ngOnInit() {
  }

  salvarNovaSenha() {
    if (this.senhanova === "" || this.senhaconfirmar === "") {
      this.toastr.warning('Informe sua nova senha!', 'Atenção!');
    } else {
      if (this.senhaconfirmar === this.senhanova) {
        this.spinner.show();
        this.apiService.getListagemIds('trocarsenharecuperar', this.lojistaid, this.senhanova)
          .subscribe(
            (data) => { //start of (1)

              this.spinner.hide();
              this.toastr.success('Senha atualizada com sucesso!');
              this.router.navigate(['/'], { replaceUrl: true });

            }, //end of (1)
            (error: any) => console.log(JSON.parse(JSON.stringify(error))), //(2) second argument
            () => console.log('all data gets') //(3) second argument
          );
      } else {
        this.toastr.warning('As senhas informadas não conferem!');
      }
    }
  }

}
